import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'lodash';
import { Observable } from 'rxjs';
import { API_URL } from '../constants';
import { IEnumResponse } from '../models/enumeration.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(
    private httpClient: HttpClient
  ) {}


  /**
   * Get all genre enumeration
   * @returns
   */
  getGenreEnum(): Observable<IEnumResponse> {
    return this.httpClient
      .get<IEnumResponse>(
        `${API_URL}/common/list-genre`
      );
  }

  /**
   * Get all type adress enumeration
   * @returns
   */
  getTypeAdressEnum(): Observable<IEnumResponse> {
    return this.httpClient
      .get<IEnumResponse>(
        `${API_URL}/common/list-type-adresse`
      );
  }

  /**
   * Get all jour enumeration
   * @returns
   */
  getJourEnum(): Observable<IEnumResponse> {
    return this.httpClient
      .get<IEnumResponse>(
        `${API_URL}/common/list-jour`
      );
  }

  /**
   * Get all mois enumeration
   * @returns
   */
  getMoisEnum(): Observable<IEnumResponse> {
    return this.httpClient
      .get<IEnumResponse>(
        `${API_URL}/common/list-mois`
      );
  }

  /**
   * Get all type personne enumeration
   * @returns
   */
  getTypePersonneEnum(): Observable<IEnumResponse> {
    return this.httpClient
      .get<IEnumResponse>(
        `${API_URL}/common/list-type-personne`
      );
  }

  /**
   * Get all statut demande enumeration
   * @returns
   */
  getStatutDemandeEnum(): Observable<IEnumResponse> {
    return this.httpClient
      .get<IEnumResponse>(
        `${API_URL}/common/list-statut-demande`
      );
  }

  /**
   * Get all type demande enumeration
   * @returns
   */
  getTypeDemandeEnum(): Observable<IEnumResponse> {
    return this.httpClient
      .get<IEnumResponse>(
        `${API_URL}/common/list-type-demande`
      );
  }

  /**
   * Get all type forfait enumeration
   * @returns
   */
  getForfaitEnum(): Observable<IEnumResponse> {
    return this.httpClient
      .get<IEnumResponse>(
        `${API_URL}/common/list-type-forfait`
      );
  }

  getCountry(): Observable<any> {
    return this.httpClient
      .get<any>(
        `https://restcountries.com/v3.1/all`
      );
  }
}
